import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"

import MonitorExpireListComponent from "components/MonitorExpireReceipts copy/list"
import {
  exportMonitorExpireReceipts,
  getMonitorExpireReceipts,
} from "store/monitor-expire-receipts/monitor-expire-action"

const MonitorExpireReceiptList = () => {
  // Meta Title
  document.title = "Expire Receipts"

  const dispatch = useDispatch()
  const {
    data,
    error,
    loading,
    exportExpireReceipt: exportStatus,
  } = useSelector(state => ({
    data: state.monitorExpireReceipts.data,
    error: state.monitorExpireReceipts.error,
    loading: state.monitorExpireReceipts.loading,
    exportExpireReceipt: state.monitorExpireReceipts.exportExpireReceipt,
  }))
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })
  const [advnacedSearch, setAdvancedSearch] = useState({})

  // Fetches new activity logs when a page number is clicked
  const onPageClick = link => {
    dispatch(
      getMonitorExpireReceipts(
        link.url,
        pageNumber,
        according,
        search,
        advnacedSearch,
        6
      )
    )
  }

  // Updates search value when a new search is performed
  const onSearchHandler = value => {
    setSearch(value)
  }

  // Updates the number of rows displayed based on user selection (e.g., 10, 20, 50)
  const onChangeRowNumber = value => {
    setPageNumber(value)
  }

  // Updates the ordering based on user selection
  const onChangeOrdering = value => {
    if (value.order) {
      setAccording(prev => {
        return { ...prev, order: value.order }
      })
    }
    if (value.name) {
      setAccording(prev => {
        return { ...prev, name: value.name }
      })
    }
  }

  // fetch new Provider Distribution Action Requests based search entered
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(
        getMonitorExpireReceipts(
          undefined,
          undefined,
          undefined,
          search,
          advnacedSearch,
          6
        )
      )
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [search])

  // fetch new Provider Distribution Action Requests based page number or according changes
  useEffect(() => {
    dispatch(
      getMonitorExpireReceipts(
        undefined,
        pageNumber,
        according,
        search,
        advnacedSearch,
        6
      )
    )
  }, [pageNumber, according])

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = data => {
    setAdvancedSearch(data)
    dispatch(
      getMonitorExpireReceipts(undefined, undefined, undefined, search, data, 6)
    )
  }

  // Trigger export process when Export button is clicked
  const onExportBtnClick = () => {
    dispatch(
      exportMonitorExpireReceipts(undefined, undefined, search, advnacedSearch)
    )
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Expire Receipts"} />
      {/* Expire Receipt Component  */}
      <MonitorExpireListComponent
        data={data}
        error={error}
        loading={loading}
        onPageClick={onPageClick}
        onSearch={onSearchHandler}
        onChangeRowNumber={onChangeRowNumber}
        onChangeOrdering={onChangeOrdering}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onExportBtnClick={onExportBtnClick}
        exportStatus={exportStatus}
      />
    </React.Fragment>
  )
}

export default MonitorExpireReceiptList
